import { Chip } from '@mui/material';
import { ADS_ACTION_STATUS_COLORS } from '../../../../../helpers/adsActionsConstants';

export const StatusChip = ({ status }) => {
  if (!status) return null;
  return <Chip size="small" label={status} color={ADS_ACTION_STATUS_COLORS[status] || 'default'} />;
};
